module.exports = __webpack_public_path__ + "assets/img/IMG050.8501ba78.png";